import { createReducer } from '@reduxjs/toolkit';
import {
    ALL_PUBLISHED_PROMOTIONS, FEATURED_PROMOTIONS,
    CLOSED_PROMOTIONS, END_FETCHING,
} from '../actions/PromotionsActions';


const initialState = {
    allPublishedPromotions: [],
    featuredPromotions: [],
    closedPromotions: [],
    // filiaisWithPromotionsPublished: [],
    // isFetching: false,
};

const promotions = createReducer(initialState, (builder) => {
    builder
        .addCase(ALL_PUBLISHED_PROMOTIONS, (state, action) => {
            state.allPublishedPromotions = action.data;
        })
        .addCase(FEATURED_PROMOTIONS, (state, action) => {
            state.featuredPromotions = action.data;
        })
        .addCase(CLOSED_PROMOTIONS, (state, action) => {
            state.closedPromotions = state.closedPromotions.concat(action.data);
        })
        // FILIAIS_PROMOTIONS_PUBLISHED and IS_FETCHING are unused (filiaisWithPromotionsPublished/isFetching are dead fields, kept as in the pre-migration reducer)
        .addCase(END_FETCHING, (state) => {
            state.isFetching = false;
        });
});

export default promotions;
